<template>
  <ul class="weui-media-box__info">
    <slot></slot>
  </ul>
</template>
<script>
export default {
  name: 'WeuiMediaInfo'
}
</script>